export function LoadingState({ label = "Loading..." }) {
  return <div className="empty-state"><p>{label}</p></div>;
}

export function ErrorState({ message, onRetry, title = 'Something went wrong' }) {
  const busy = typeof message === 'string' && (message.startsWith('Insights are temporarily busy.') || message.startsWith('Analytics is temporarily busy.'));
  return (
    <div className="empty-state">
      <h4>{busy ? 'Insights are temporarily busy' : title}</h4>
      <p>{message}</p>
      {onRetry && (
        <button className="btn btn-secondary btn-sm" onClick={onRetry}>Retry</button>
      )}
    </div>
  );
}
